import angular from 'angular';
import common from './core.module';
import playersModule from './players.module';
import configModule from './config.module';
import BookingsController from './controllers/bookings/bookings.controller';
import BookingsCreateController from './controllers/bookings/create.controller';
import BookingsEditController from './controllers/bookings/edit.controller';
import BookingsEditDeleteController
  from './controllers/bookings/edit.delete.controller';
import BookingsEditDoneController
  from './controllers/bookings/edit.done.controller';
import BookingsEditQualificationsController
  from './controllers/bookings/edit.qualifications.controller';

import BookingTypeMetadataViewComponent
  from './components/booking-type-metadata/booking-type-metadata.view.component';
import {
  BookingTypeMetadataEditComponent,
  BookingTypeMetadataEditModal,
} from './components/booking-type-metadata/booking-type-metadata.edit.component';

import {
  PlayersOfflineService,
  PlayersOfflineController,
} from './services/PlayersOffline.service';

const moduleName = 'atc-bookings';
angular
  .module (moduleName, [common, playersModule, configModule])
  .controller ('BookingsCreateController', BookingsCreateController)
  .controller ('BookingsEditController', BookingsEditController)
  .controller ('BookingsEditDeleteController', BookingsEditDeleteController)
  .controller ('BookingsEditDoneController', BookingsEditDoneController)
  .controller (
    'BookingsEditQualificationsController',
    BookingsEditQualificationsController
  )
  .component ('bookingTypeMetadataView', BookingTypeMetadataViewComponent)
  .component ('bookingTypeMetadataEdit', BookingTypeMetadataEditComponent)
  .controller ('BookingsController', BookingsController)
  .service ('BookingTypeMetadataEditModal', BookingTypeMetadataEditModal)
  .service ('PlayersOffline', PlayersOfflineService)
  .controller ('PlayersOfflineController', PlayersOfflineController);

export default moduleName;
